import request, { ARTICLE_API, ARTICLE_API2 } from "./request"
import {BASE_URL} from "./savePoint";
function cleanArray(actual) {
    const newArray = []
    for (let i = 0; i < actual.length; i++) {
        if (actual[i]) {
            newArray.push(actual[i])
        }
    }
    return newArray
}
function param(json) {
    if (!json) return ''
    return cleanArray(Object.keys(json).map(key => {
        if (json[key] === undefined) return ''
        return encodeURIComponent(key) + '=' +
            encodeURIComponent(json[key])
    })).join('&')
}
export const getPoster = (params) => {
    // params.timestamp = Date.now()
    return request({
        url: `${ARTICLE_API}/article/list`,
        // url: `${ARTICLE_API}/article/list?${param(params)}`,
        // url: `https://testpc.nfapp.southcn.com/nfplus-manuscript-web/article/list?${param(params)}`,
        // url: `https://testhd.nfapp.southcn.com/nfplus-manuscript-web/article/list?${param(params)}`,
        method: "get",
        params
    })
}
export const getTab = (params) => {
    // params.timestamp = Date.now()
    return request({
        url: ARTICLE_API2,
        method: "get",
        params
    })
}
export const getBlessNum = (data) => {
    return request({
        url: `https://h5.oeeee.com/rest/v21/rest/thumbup/click`,
        method: "post",
        data
    })
}